<script>
//import TransitionExpand from "~/src/components/transition-expand.vue";

import sizeVue from "~/src/mixins/size.vue";

import Step1 from "./step-1.vue";

export default {
  props: {
    isReadonly: {
      type: Boolean,
      default: () => false,
    },
  },

  components: {
    Step1,
  },

  data: () => ({
    currentStep: 1,
    steps: 1,
  }),

  mixins: [sizeVue],

  methods: {
    onNextStep() {
      if (this.currentStep < this.steps) {
        this.currentStep++;
      } else {
        this.currentStep--;
      }
    },

    onPrevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
  },
};
</script>

<template>
  <div>
    <!--    <v-text-field
      autocomplete="off"
      class="text-field"
      solo
      placeholder="AA1234567"
      required
      :rules="[$rules.passport]"
      v-inputmask="$masks.passport"
    />-->
    <v-container>
      <v-stepper elevation="0" v-model="currentStep" class="custom-stepper">
        <v-stepper-items>
          <v-stepper-content :step="1">
            <div style="padding-top: 30px"></div>
            <step-1
              :isReadonly="isReadonly"
              v-if="currentStep == 1"
              @next="onNextStep"
              @prev="onPrevStep"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <div class="py-4"></div>
    </v-container>
  </div>
</template>

<style lang="scss">
$roudSize: 58px;
$innerRoudSize: 54px;

.custom-stepper {
  max-width: 1164px;
  margin-left: auto;
  margin-right: auto;

  background-color: #f3eefb !important;

  @media only screen and(min-width:577px) {
    margin-top: 15px;
  }

  .v-stepper__header {
    box-shadow: none;
  }

  .v-stepper__step {
    &,
    &:hover {
      border-radius: 50%;
      padding: 0;
      height: $roudSize;
      width: $roudSize;
      justify-content: center;
      background-color: #f3eefb;

      .v-stepper__label {
        display: none;
      }

      .v-stepper__step__step {
        margin: 0 !important;
        height: $innerRoudSize;
        width: $innerRoudSize;
        background: #d9d9d9 !important;

        border: 4px solid white !important  ;

        i {
          font-size: 0.75rem !important;
          font-style: normal !important;
        }
      }

      &.stepper-step-complate {
        .v-stepper__step__step {
          background: #00274c !important;
        }
      }

      &.v-stepper__step--active {
        background: #00274c !important;

        .v-stepper__step__step {
          background: #00274c !important;
        }
      }
    }
  }

  .v-stepper__content {
    padding: 0;
  }
}

.text-field {
  border-radius: 10px;

  .v-input__slot {
    background-color: #ebf0f8 !important;
    box-shadow: none !important;
  }

  &.error--text {
    .v-input__slot {
      background-color: #fddee2 !important;
      box-shadow: 0 0 8px #fddee2;
    }
  }

  &.v-input--is-disabled {
    opacity: 0.7;
  }
}

.header-divider {
  border-width: 0px 0px 3px;
  transform: translateY(-6px);
  margin: 0 -2px !important;
}

.card-header {
  background-color: #00274c;
  height: 90px;
}
</style>
